import { z } from 'zod';
import { endpoint } from './endpoint.js';
import { OfferIdSchema } from '../schemas/offer.js';
import {
  OfferPeriodInquiryBodySchema,
  OfferPeriodInquiryResponseSchema,
} from '../schemas/offer-period-inquiry.js';

export const offerPeriodInquiry = {
  submit: endpoint(
    'POST',
    '/offers/:id/period-inquiry',
    z.object({ id: OfferIdSchema }).merge(OfferPeriodInquiryBodySchema),
    OfferPeriodInquiryResponseSchema,
  ),
};
